import React from 'react';

import { Copy } from 'src/common/ui/components';
import { IdSubmission } from 'src/idVerification/types';

type IdVerificationTitleProps = {
  idVerification: IdSubmission;
};

export const IdVerificationTitle = ({ idVerification }: IdVerificationTitleProps) => {
  const { missingReason, title, imageIds } = idVerification;

  const verificationTitle = !imageIds?.length ? 'No file submitted' : title;

  return (
    <>
      <Copy variant="body1">{verificationTitle}</Copy>
      {!!missingReason && (
        <>
          <br />
          <Copy variant="body2">
            <span style={{ wordBreak: 'keep-all', overflowWrap: 'break-word' }}>
              {missingReason}
            </span>
          </Copy>
        </>
      )}
    </>
  );
};
